import firebase from "firebase";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjUd3CV_5KCWOpwTDUr_0eHFzhzne-65A",
  authDomain: "rentalsols.firebaseapp.com",
  projectId: "rentalsols",
  storageBucket: "rentalsols.appspot.com",
  messagingSenderId: "911610392067",
  appId: "1:911610392067:web:9ef7637d65101297ffa836",
  measurementId: "G-KYC4LNBMGC",
};

// initialize firebase with above config
try {
  const app = firebase.initializeApp(firebaseConfig);
  const analytics = firebase.getAnalytics(app);
} catch (err) {
  // already initalized
}

export const db = firebase.firestore;
export const { auth, storage } = firebase;
// export const currentUser = () => auth().currentUser
export const serverTimestamp = () => db.FieldValue.serverTimestamp();
